import React, { useState } from "react";
import { LANGUAGES } from "../utils/i18n";

const COUNTRY_CODE: Record<string, string> = {
  fr: "fr", en: "gb", es: "es", ar: "sa", de: "de", it: "it",
  pt: "pt", zh: "cn", ru: "ru", tr: "tr", nl: "nl", pl: "pl",
};

const flagUrl = (code: string) => `https://flagcdn.com/${COUNTRY_CODE[code] || code}.svg`;

function Flag({ code, size }: { code: string; size: number }) {
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", overflow: "hidden", flexShrink: 0 }}>
      <img src={flagUrl(code)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
    </div>
  );
}

export default function LanguagePicker({ lang, setLang, size = 44, dark = false, align = "left" }: { lang: string; setLang: (l: string) => void; size?: number; dark?: boolean; align?: "left" | "right" }) {
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];
  const ringColor = dark ? "rgba(255,255,255,0.5)" : "#0a0a0a";
  const bgColor = dark ? "rgba(255,255,255,0.08)" : "#F5F5F5";

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setOpen(o => !o)}
        title={current.name}
        style={{
          width: size, height: size, borderRadius: "50%", padding: 0,
          border: `2px solid ${open ? ringColor : "transparent"}`,
          backgroundColor: bgColor, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          overflow: "hidden", transition: "border-color 0.15s",
        }}
      >
        <Flag code={current.code} size={size - 4} />
      </button>

      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div style={{
            position: "absolute", top: `calc(100% + 10px)`, [align]: 0, zIndex: 50,
            backgroundColor: "white", borderRadius: 20, padding: 10,
            boxShadow: "0 16px 40px rgba(0,0,0,0.18)", border: "1px solid #F0F0F0",
            display: "flex", flexWrap: "wrap", gap: 8, width: 5 * (size + 8) + 10,
          } as React.CSSProperties}>
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                title={l.name}
                style={{
                  width: size, height: size, borderRadius: "50%", padding: 0,
                  border: l.code === lang ? "2px solid #0a0a0a" : "2px solid transparent",
                  backgroundColor: "#F5F5F5", cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Flag code={l.code} size={size - 4} />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
